module.exports = __webpack_public_path__ + "static/media/icon_heart_empty_green.bdc6ffcb.svg";